import { Box, Card, Group, Text, Badge, Flex, Image, Button, Rating, Avatar } from '@mantine/core'
import React from 'react'
import classes from './ProgramCard.module.css'
import NoImage from '../../../assets/img/no-image.png'
import { getImageFile } from '../../../services/fileImage'
import { useNavigate } from 'react-router-dom'
import { formatPrice } from '../../../plugins/formatPrice'
import { IconMap, IconCalendarEvent, IconVideo, IconClock2, IconUsers, IconMapPin } from '@tabler/icons-react'
import dayjs from 'dayjs'
import { useViewportSize } from '@mantine/hooks'

const ProgramCard = ({ data }) => {
  const { width } = useViewportSize()
  const navigate = useNavigate()

  const formatTime = (time) => {
    return time.slice(0, -3)
  }

  const mappingSchedule = (type, latestSchedule) => {

    const mappingTypeSchedule = () => {
      if (latestSchedule !== null) {
        if (type === 'offline') {
          return (
            <Group gap='xs' mb={width > 768 ? 4 : 2} wrap='nowrap'>
              <IconMap size={width > 768 ? '1rem' : '0.8rem'} stroke='1.5' color='red' />
              <Text className={classes.titleSchedule} lineClamp={1}>{latestSchedule.address ? latestSchedule.address : '-'}</Text>
            </Group>
          )
        } else if (type === 'online') {
          const mappingTypeOnline = latestSchedule.onlineLink
          const mappingPlatformOnline = (val) => {
            if (val.includes('zoom')) {
              return 'Zoom'
            } else if (val.includes('teams')) {
              return 'Microsoft Teams'
            } else if (val.includes('meet.google')) {
              return 'Google Meet'
            }
          }
          return (
            <Group gap='xs' mb={width > 768 ? 4 : 2} wrap='nowrap'>
              <IconVideo size={width > 768 ? '1rem' : '0.8rem'} stroke='1.5' color='red' />
              <Text className={classes.titleSchedule} lineClamp={1}>{mappingPlatformOnline(mappingTypeOnline)}</Text>
            </Group>
          )
        } else if (type === 'hybrid') {
          return (
            <Group gap='xs' mb={width > 768 ? 4 : 2} wrap='nowrap'>
              <IconMapPin size={width > 768 ? '1rem' : '0.8rem'} stroke='1.5' color='red' />
              <Text className={classes.titleSchedule} lineClamp={1}>Hybrid</Text>
            </Group>
          )
        }
      } else {
        return (
          <Group gap='xs' mb={width > 768 ? 4 : 2}>
            <IconVideo size={width > 768 ? '1rem' : '0.8rem'} stroke='1.5' color='red' />
            <Text className={classes.titleSchedule} lineClamp={1}>Belum Tersedia</Text>
          </Group>
        )
      }
    }

    return (
      <Box className={classes.metaLocation}>
        <Group gap='xs' mb={width > 768 ? 4 : 2}>
          <IconCalendarEvent size={width > 768 ? '1rem' : '0.8rem'} stroke='1.5' color='red' />
          <Text className={classes.titleSchedule} lineClamp={1}>{latestSchedule !== null ? dayjs(latestSchedule.eventStart).format('DD MMMM YYYY') : 'Belum Tersedia'}</Text>
        </Group>
        <Group gap='xs' mb={width > 768 ? 4 : 2}>
          <IconClock2 size={width > 768 ? '1rem' : '0.8rem'} stroke='1.5' color='red' />
          <Text className={classes.titleSchedule} lineClamp={1}>{latestSchedule !== null ? `${formatTime(latestSchedule.timeStart)} - ${formatTime(latestSchedule.timeEnd)}` : 'Belum Tersedia'}</Text>
        </Group>
        {mappingTypeSchedule()}
      </Box>
    )
  }

  const mappingTutors = (dataTutors) => {
    if (dataTutors.length < 1) {
      return ("")
    }
    const detailTutor = dataTutors[0]
    const innerHtml = { __html: detailTutor.user.profile.shortProfile }
    return (
      <Flex align='start' mt={width > 768 ? 20 : 4}>
        <Avatar mr={width > 768 ? 16 : 10} radius='xl' size={width > 768 ? 50 : 30} src={detailTutor.user.image !== "" ? getImageFile(detailTutor.user.image) : null} alt={detailTutor.user.fullName} />
        <Box>
          <Text fz={width > 768 ? 'sm' : 10} mb={-10} fw="bold" lineClamp={1}>{detailTutor.user.fullName}</Text>
          <Text fz={width > 768 ? 'xs' : 8} fw='500' lineClamp={1} h={30}>{detailTutor.user.profile.shortProfile ? (<Box dangerouslySetInnerHTML={innerHtml} />) : '-'}</Text>
        </Box>
      </Flex>
    )
  }

  const mappingPrice = (typeTraining) => {
    if (typeTraining === 'course') {
      return (
        <Text className={classes.priceProgram} c="red">{formatPrice(data.price)}</Text>
      )
    } else {
      return (
        <Text className={classes.priceProgram} c="red">{data.latestSchedule !== null ? formatPrice(data.latestSchedule.price) : 'Belum Tersedia'}</Text>
      )
    }
  }

  const mappingButton = (typeTraining) => {
    if (typeTraining === 'course') {
      return (
        <Button className={classes.buttonProgram} fullWidth color='indigo.9'>Mulai Belajar</Button>
      )
    } else {
      if (data.latestSchedule === null) {
        return (
          <Button className={classes.buttonProgram} fullWidth color='red.9'>Kelas Belum Tersedia</Button>
        )
      } else {
        if (data.latestSchedule.status === 'done') {
          return (
            <Button className={classes.buttonProgram} fullWidth color='red.9'>Kelas Ditutup</Button>
          )
        } else {
          return (
            <Button className={classes.buttonProgram} fullWidth color='indigo.9'>Daftar Sekarang</Button>
          )
        }
      }
    }
  }

  return (
    <Card className={classes.programCard} shadow='sm' radius='md' padding={width > 768 ? 8 : 6} withBorder onClick={() => navigate(`/${data.kind}/${data.slug}`)}>
      <Card.Section pos='relative'>
        <Image src={data.eventImages.length === 0 ? NoImage : getImageFile(data.eventImages[0].filepath)} />
        <Box className={classes.typeProgram}>
          <Badge color='#ff860b' variant="filled" size={width > 768 ? 'xs' : 10} fz={width > 768 ? 8 : 6} >
            {data.eventCategory.name}
          </Badge>
        </Box>
      </Card.Section>
      <Box p={width > 768 ? 4 : 2}>
        <Flex justify={data.userRating !== null ? 'space-between' : 'flex-end'} align='center' my={width > 768 ? 8 : 6} mx={2}>
          {data.userRating !== null ? (<Rating size={width > 768 ? 'xs' : 9} defaultValue={data.userRating} fractions={5} readOnly />) : ''}
          <Group gap={4} align='center' wrap='noWrap'>
            <IconUsers size={width > 768 ? '1rem' : '0.7rem'} stroke='1.5' />
            <Text className={classes.titleSchedule} lineClamp={1}>{data.participantCount} User Terdaftar</Text>
          </Group>
        </Flex>
        <Box>
          <Text className={classes.titleProgram} lineClamp={2}>{data.name}</Text>
        </Box>
        {data.type !== 'course' ? mappingSchedule(data.type, data.latestSchedule) : mappingTutors(data.tutors)}
        <Box my={12}>
          <Flex justify="end" align="center" className={classes.textLineThrought} h={20}>
            <Text className={classes.blinkPrice} c="red">{data.latestSchedule !== null && data.latestSchedule.price < data.price ? formatPrice(data.price) : ''}</Text>
          </Flex>
          <Flex justify={data.latestSchedule !== null ? 'space-between' : 'end'} align="center">
            <Text className={classes.discountText} c="red">{data.latestSchedule !== null && data.latestSchedule.price < data.price ? `${((data.price - data.latestSchedule.price) / data.price * 100).toFixed(0)}%` : ''}</Text>
            {mappingPrice(data.kind)}
          </Flex>
        </Box>
        <Box>
          {mappingButton(data.kind)}
        </Box>
      </Box>
    </Card>
  )
}

export default ProgramCard